// extracted by mini-css-extract-plugin
module.exports = {"tableTitleCell":"StructureInformation_tableTitleCell__2hekU","dataClassCell":"StructureInformation_dataClassCell__21PSL"};